import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    categories: [
      {
        slug: 'feminismo',
        name: 'Feminismo en el aula'
      },
      {
        slug: 'edfisica',
        name: 'Educación Física'
      },
    ],
    articles: [
      {
        title: 'Descubre las herramientas claves para crecer en el mercado laboral',
        slug: 'herramientas-clave-para-crecer',
        beforetitle: 'Unegocios:',
        undertitle: 'Con profesores líderes en materia de investigación y con gran vinculación en el mundo empresarial, Unegocios busca generar nuevas competencias, según las necesidades de cada estudiante.',
        // img: 'content/entrevista-1.jpg',

        img: 'content/01.jpg',
        category: 'edfisica',
        content: '<div class="wrap"><p> La Facultad de Economía y Negocios de la Universidad de Chile, a través de Unegocios, ofrece una serie de diplomados y cursos, que tienen por objetivo entregar mayores conocimientos a quienes tengan interés por desempeñarse en el área empresarial. Su modelo de educación continua, busca que los estudiantes que deseen especializarse o aceptar nuevos desafíos, se mantengan al día con las habilidades y destrezas necesarias para crecer laboralmente.</p><VideoPlayer iframe=\'<iframe id="vrudo" class="vrudo" src="//rudo.video/vod/bHdxUe" width="560" height="315" allowscriptaccess="always" allowfullscreen="true" webkitallowfullscreen="true" frameborder="0" scrolling="no" allow="autoplay; fullscreen" ></iframe>\'></VideoPlayer><ViewMore /><p> Los diplomados presenciales y online –para quienes necesitan más flexibilidad horaria– están enfocados en proporcionar herramientas para asumir funciones gerenciales, de coordinación de equipos multidisciplinarios, marketing y ventas, finanzas e inversiones y dirección de instituciones de salud.</p><p> Una alternativa distinta, son los cursos presenciales y online, que buscan que los estudiantes, en un periodo más corto, puedan tener una visión más general, conceptual y práctica de cómo funcionan los negocios.</p><p> Los académicos de Unegocios no solo participan de forma activa en investigaciones que posteriormente transmiten a sus alumnos, sino que también cumplen labores fundamentales en empresas, lo que les permite enseñar desde sus propias experiencias.</p></div>',
        // alignment: 'left top',
        share: {
          title: 'Unegocios: Descubre las herramientas claves para crecer en el mercado laboral',
          description: 'Con profesores líderes en materia de investigación y con gran vinculación en el mundo empresarial, Unegocios busca generar nuevas competencias, según las necesidades de cada estudiante.',
          img: 'content/01.jpg',
        },
        credits: [
          {
            title: 'Textos',
            author: 'Belén Peña L.'
          }
        ],
      },
      {
        title: '“Haber realizado este diplomado me ha dado mucha más seguridad laboral”',
        beforetitle: 'Sandra Tapia, egresada Unegocios:',
        slug: 'sandra-tapia-egresada-unegocios',
        undertitle: 'El prestigio de la Universidad de Chile la llevó a tomar la decisión de estudiar allí, lo que le permitió adquirir las competencias y destrezas necesarias para aceptar nuevos desafíos.',
        img: 'content/02.jpg',
        // img: 'content/entrevista-1.jpg',
        category: 'feminismo',
        // alignment: 'left top',
        content: '<div class="wrap"><p> Tras ver frustrado su plan inicial de tener una carrera profesional, por diferentes situaciones que postergaron su decisión, Sandra Tapia (42), decidió ingresar a Unegocios, de la Universidad de Chile, y estudiar el diplomado de gestión estratégica de recursos humanos.</p><VideoPlayer iframe=\'<iframe id="vrudo" class="vrudo" src="//rudo.video/vod/bHd0kW" width="560" height="315" allowscriptaccess="always" allowfullscreen="true" webkitallowfullscreen="true" frameborder="0" scrolling="no" allow="autoplay; fullscreen" ></iframe>\'></VideoPlayer><ViewMore /><p>&nbsp;</p><p> Su elección se basó en el prestigio de la casa de estudios y la variedad de contenidos ofrecidos. “Cuando me inscribí en el diplomado, pensé que iba a ser solamente para personas con carreras profesionales”, cuenta.</p><p> Los nuevos conocimientos y habilidades que adquirió, no solo le permitieron crecer en materia profesional, sino que también aumentaron su confianza. “Haber realizado este diplomado me ha dado mucha más seguridad laboral”.</p></div>',
        share: {
          title: 'Sandra Tapia, egresada Unegocios: “Haber realizado este diplomado me ha dado mucha más seguridad laboral”',
          description: 'El prestigio de la Universidad de Chile la llevó a tomar la decisión de estudiar allí, lo que le permitió adquirir las competencias y destrezas necesarias para aceptar nuevos desafíos.',
          img: 'content/02.jpg',
        },
        credits: [
          {
            title: 'Textos',
            author: 'Belén Peña L.'
          }
        ],
      },
      {
        title: '“La modalidad weekend me permitió compatibilizar estudios, ambiente laboral y vida personal”',
        slug: 'ana-san-martin-egresada-unegocios',
        beforetitle: 'Ana San Martín, egresada Unegocios:',
        undertitle: 'Con los conocimientos que adquirió en el diplomado obtuvo mayores herramientas para crecer profesionalmente, logrando cambiarse de trabajo y de rubro. ',
        // img: 'content/entrevista-1.jpg',

        img: 'content/03.jpg',
        category: 'edfisica',
        content: '<div class="wrap"><p> Su formación como ingeniera en prevención de riesgos, le entregó a Ana San Martín las competencias necesarias para desempeñarse en el mundo laboral. Sin embargo, su inquietud por especializarse la llevó a cursar el diplomado en Gestión de Negocios, de Unegocios, de la Universidad de Chile.</p><p> Tomar esta decisión derivó en que pudiera cambiarse de trabajo y de rubro. “Me entregó herramientas financieras para manejar presupuestos, con un mayor conocimiento del que tenía”, asegura.</p><VideoPlayer iframe=\'<iframe id="vrudo" class="vrudo" src="//rudo.video/vod/bHdxUI" width="560" height="315" allowscriptaccess="always" allowfullscreen="true" webkitallowfullscreen="true" frameborder="0" scrolling="no" allow="autoplay; fullscreen" ></iframe>\'></VideoPlayer><ViewMore /><p> A diferencia de otros cursos, este solo se imparte los viernes y sábados, lo que le permitió lograr un equilibrio en todos los aspectos de su vida. “La modalidad <em>weekend</em> hizo que pudiera compatibilizar estudios, ambiente laboral y vida personal”, destaca.</p></div>',
        // alignment: 'left top',
        share: {
          title: 'Ana San Martín, egresada Unegocios: “La modalidad weekend me permitió compatibilizar estudios, ambiente laboral y vida personal”',
          description: 'Con los conocimientos que adquirió en el diplomado obtuvo mayores herramientas para crecer profesionalmente, logrando cambiarse de trabajo y de rubro.',
          img: 'content/03.jpg',
        },
        credits: [
          {
            title: 'Textos',
            author: 'Belén Peña L.'
          }
        ],
      },
    ],
    config: {
      logo: 'assets/images/logos/latercera.svg',
      title: 'Facultad de Economía de la Universidad de Chile',
      url: 'https://www.latercera.com/canal/tendencias',
      papeldigital: true,
      baseurl: 'https://especiales.latercera.com/unegocios/',
      description: 'La Universidad',
      hashtag: '#ucsh',
      brandtitle: 'Presentado por la Facultad de Economía de la Universidad de Chile',
      reporttitle: 'Especiales La Tercera',
      undertitle: 'Una serie de diplomados y cursos, en modalidad presencial y online, son los que ofrece la Universidad de Chile, a través de Unegocios. Sus programas están enfocados principalmente a quienes deseen profundizar sus conocimientos, y mejorar sus habilidades y competencias para crecer en el mundo laboral.',
      jumbo: {
        // img: 'content/main.jpg',
        undertitle: 'Una serie de diplomados y cursos, en modalidad presencial y online, son los que ofrece la Universidad de Chile, a través de Unegocios. Sus programas están enfocados principalmente a quienes deseen profundizar sus conocimientos, y mejorar sus habilidades y competencias para crecer en el mundo laboral.',
        video: 'content/fen-compressed.mp4'
      },
      img: 'content/share.jpg',
      slug: '/',
      lab: {
        logo: 'assets/images/logos-white/laboratorio-de-contenidos-de-marca.svg',
        title: 'Laboratorio de Contenidos',
        url: {
          name: "home"
        },
        height: '30'
      },
      brand: {
        logo: 'assets/images/logos-white/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '20'
      },
      sponsor: {
        logo: 'content/logo-unegocios.svg',
        title: 'Unegocios de la Facultad de Economía Universidad de Chile',
        url: {
          name: "home"
        },
        height: '45'
      },
      special: {
        logo: 'assets/images/logo-oportunidades.svg',
        title: 'Unegocios: “Oportunidades para seguir creciendo” ',
        url: {
          name: "home"
        },
        height: '40'
      },
      front: {
        logo: 'assets/images/logo-oportunidades.svg',
        title: 'Unegocios: “Oportunidades para seguir creciendo” ',
        url: {
          name: "home"
        },
        height: '300'
      },
      site: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '37'
      },
      menu: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '13'
      },
      'papeldata': {
        url: 'https://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
        image: 'https://edition.pagesuite-professional.co.uk/get_image.aspx?w=300&pbid=33084897-397a-48cc-b3c0-3ce1ec447137&pnum=01&nocache=0609201815'
      },
      'navigation': [
        {
          url: 'https://www.latercera.com/',
          name: 'Inicio'
        },
        {
          url: 'https://www.latercera.com/la-tercera-pm/',
          name: 'La Tercera PM'
        },
        {
          url: 'https: //www.latercera.com/canal/pulso/',
          name: 'Pulso'
        },
        {
          url: 'https://www.latercera.com/canal/politica/',
          name: 'Política'
        },
        {
          url: 'https://www.latercera.com/canal/nacional/',
          name: 'Nacional'
        },
        {
          url: 'https://www.latercera.com/canal/mundo/',
          name: 'Mundo'
        },
        {
          url: 'https://www.latercera.com/canal/opinion/',
          name: 'Opinión'
        },
        {
          url: 'https://www.latercera.com/canal/tendencias/',
          name: 'Tendencias'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Cultura'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Entretención'
        },
        {
          url: 'https://www.latercera.com/canal/reportajes/',
          name: 'Reportajes'
        },
        {
          url: 'https://www.latercera.com/canal/el-deportivo/',
          name: 'El Deportivo'
        },
        {
          url: 'https://www.latercera.com/canal/la-tercera-tv/',
          name: 'La Tercera TV'
        },
        {
          url: 'http://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
          name: 'Edición Impresa'
        }
      ],
      'socialnetworks': [
        {
          url: 'https://twitter.com/latercera',
          icon: 'twitter', //TODO, cargar svgs dinámicamente en init
          name: 'Twitter'
        },
        {
          url: 'https://www.facebook.com/laterceracom',
          icon: 'facebook-f', //TODO, cargar svgs dinámicamente en init
          name: 'Facebook'
        },
        {
          url: 'https://flipboard.com/@latercera',
          icon: 'flipboard', //TODO, cargar svgs dinámicamente en init
          name: 'Flipboard'
        },
        {
          url: 'https://www.instagram.com/laterceracom/',
          icon: 'instagram', //TODO, cargar svgs dinámicamente en init
          name: 'Instagram'
        },
        {
          url: 'https://www.youtube.com/user/latercera',
          icon: 'youtube', //TODO, cargar svgs dinámicamente en init
          name: 'Youtube'
        }
      ]
    }
  },
  mutations: {
    SET_LOGO: (state, val) => {
      state.config.logo = val
    }
  },
  actions: {
    setLogo(context, val) {
      context.commit('SET_LOGO', val)
    }
  },
  getters: {
    getArticle: (state) => (slug) => {
      const articlearr = state.articles.filter(i => i.slug === slug)
      return articlearr[0]
    },
    getArticleIndex: (state) => (slug) => {
      const articleIndex = state.articles.findIndex(i => i.slug === slug)
      return articleIndex
    },
    getArticlesByCategory: (state) => (category) => {
      const articlearr = state.articles.filter(i => i.category === category)
      return articlearr
    }
  }
})
